module.exports = __webpack_public_path__ + "img/zeus.6e7bea7e.jpg";